/**
 * Checkbox used on Step05 Quote Variation
 * inside the Cover options menu
 *
 * @param {function} handleItemChange [This should have the function so set the value on the parent]
 * @param {boolean} checked           [Have the option to Check or Uncheck the box. Default: false]
 * @param {string} title              [Text printed next to the checkbox]
 * @param {string} id                 [Name of the field]
 * @param {ReactDOM} children         [Description of the ToolTip, would be the child]
 */

/**
 *     Import
 *     - Libraries
 */
import * as React from 'react'

import Checkbox from '../../../../common/Checkbox/Checkbox'
import ToolTip from '../../../../common/ToolTip/ToolTip'

export default class OptionsCheckbox extends React.Component<any, any> {

    constructor(props: any) {
        super(props)
        this.state = {
            checked: this.props.checked || false,
        }
    }

    handleCheckbox = (value: any, field: string) => {
        this.props.handleItemChange(field, value)
        this.setState({ checked: !this.state.checked })
    }

    render() {
        const { tooltipView = true } = this.props
        return (
            <div className={`options__item options__item--checkbox options__item--${this.props.id}`}>
                <Checkbox name={this.props.id} selected={this.state.checked} onChange={this.handleCheckbox}>
                    <span>{this.props.title}</span>
                    {tooltipView && (
                        <ToolTip
                            verticalPosition=
                            {`${this.props.tooltipVerticalPosition ? this.props.tooltipVerticalPosition : null}`}
                        >
                            {this.props.children}
                        </ToolTip>
                    )}
                </Checkbox>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/pages/Quote/Step05/components/OptionsCheckbox.tsx